import axios from 'axios';
import { makeForm } from './utils';

const env = process.env.REACT_APP_DEPLOY_ENV || 'staging';

const BACKENDS = {
  dev: '-dev',
  staging: '-staging',
  prod: ''
};

// const scheme =
//   navigator.appVersion.toLocaleLowerCase().indexOf('ucbrowser') === -1
//     ? 'https'
//     : 'http';
const baseURL = `https://api${BACKENDS[env]}.latiproduct.net`;

const _axios = axios.create({
  baseURL
});

export const transaction = {
  init: payData => {
    // 微信授权域名为api.latiproduct.net，所以此处必须是api.latiproduct.net，否则无法获取code
    // staging测试需要修改hosts，跳到staging的IP

    const path = '/v3/staticpay';

    //待优化：支付宝可以axios post，能获得API结果，方便提示用户
    //微信暂时只能使用makeform，应该api.latiproduct.net重定向到微信

    if (payData.payment_method === 'alipay') {
      const params = new URLSearchParams();
      Object.keys(payData).forEach(key => {
        params.append(key, payData[key]);
      });

      window.location.href = `${baseURL}${path}?${params.toString()}`;
    } else {
      makeForm(`${baseURL}${path}`, payData);
    }

    //支付宝 重定向到 qrcode_url
    //微信 重定向到 pay.latipay.net/pay/wechat_in_app
  },
  query: orderId => _axios.post('/v3/queryorder', { orderId }),
  makeOffline: order => _axios.post('/v2/transaction', order),
  nonce: url => _axios.get(url)
};

export const staticQR = {
  get: (paymentMethod, userId, walletId) =>
    _axios.get(`/v2/staticqrpaydata/${paymentMethod}/${userId}/${walletId}`),
  getWalletInfoByUserId: (userCode, accountCode) =>
    _axios.get(
      `/v3/static-code?userCode=${userCode}&accountCode=${accountCode}`
    ),
  getWalletInfoByCompany: (organisationCode, shortCode) =>
    _axios.get(`/v3/static-code/${organisationCode}/${shortCode}`)
};

export default {
  transaction,
  staticQR
};



// WEBPACK FOOTER //
// ./src/api.js